export type LegacySettingsLocationState = {
  fromSettingsBeta?: boolean;
  /** Beta page the "Back to Settings (Beta)" link returns to, instead of the tab's equivalent */
  backTo?: string;
  /** Defect type (organization) whose drawer opens on the legacy Defects tab */
  defectTypeId?: string;
};

const settingsBetaPathByLegacyTab: Record<string, string> = {
  users: '/settings_beta/team',
  stores: '/settings_beta/network/entities',
  'external-stores': '/settings_beta/network/entities',
  'internal-workshops': '/settings_beta/network/entities',
  groups: '/settings_beta/network/groups',
  actions: '/settings_beta/services/actions',
  'spare-part-types': '/settings_beta/services/spare-parts',
  'defect-types': '/settings_beta/services/defects',
  'condition-forms': '/settings_beta/workflows/condition-forms',
  workflows: '/settings_beta/workflows',
  companies: '/settings_beta/billing',
};

/**
 * Settings beta page showing the same content as a legacy Settings tab
 */
export const getSettingsBetaPath = (legacyTab: string): string =>
  settingsBetaPathByLegacyTab[legacyTab] ?? '/settings_beta';
